import { render, staticRenderFns } from "./StrokeSolidIcon.vue?vue&type=template&id=3b40f57d&"
import script from "./StrokeSolidIcon.vue?vue&type=script&lang=js&"
export * from "./StrokeSolidIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports